import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'pc-button',
  props: {
    position: null,
    bg: null,
    active: null,
    hover: null,
    width: null,
    height: null,
    top: null,
    left: null
  },
  setup(__props) {
    const props = __props;
    _useCssVars((_vm, _setup) => ({
      "a3ad7744": _setup.active,
      "570c0e38": _setup.hover
    }));
    const style = computed(() => {
      var _props$bg2;
      const w = typeof props.width === 'number' ? `${props.width / 100}rem` : props.width;
      const h = typeof props.height === 'number' ? `${props.height / 100}rem` : props.height;
      const top = typeof props.top === 'number' ? `${props.top / 100}rem` : props.top;
      const left = typeof props.left === 'number' ? `${props.left / 100}rem` : props.left;
      if (props.position === 'relative') {
        var _props$bg;
        return {
          position: props.position,
          width: w,
          height: h,
          top: isNil(top) ? 'auto' : top,
          left: isNil(left) ? 'auto' : left,
          backgroundImage: `url(${(_props$bg = props.bg) !== null && _props$bg !== void 0 ? _props$bg : ''})`
        };
      }
      return {
        position: props.position,
        width: w,
        height: h,
        top,
        left,
        backgroundImage: `url(${(_props$bg2 = props.bg) !== null && _props$bg2 !== void 0 ? _props$bg2 : ''})`
      };
    });
    const active = computed(() => props.active ? `url(${props.active})` : '');
    const hover = computed(() => props.hover ? `url(${props.hover})` : '');
    return {
      __sfc: true,
      props,
      style,
      active,
      hover
    };
  }
});